import httpService from "./httpService";
import { getUserId } from "./httpService";
import { getBaseUrl } from "../helpers/baseUrlHelper";

const orderNotFound = "Order not found/404";

const errorDetails = message => {
	return [
		{
			errorFlag: true,
			errorDescription: getDescription(message),
			errorTitle: "Unable to retrieve the order"
		}
	];
};

function getDescription(message) {
	switch (message) {
		case orderNotFound:
			return "Order not found. Please search for a valid order number.";
		case "undefined":
			return "Order Not Found";
		default:
			return message;
	}
}

const OrderSearchService = {
	getOrderDetails: async (orderNumber, countryCode) => {
		let userId = await getUserId();
		const searchOrderUrl = `${getBaseUrl()}order?orderNo=${orderNumber}&countryCode=${countryCode}&userId=${userId}`;
		let response = await httpService
			.get(searchOrderUrl, { useAuth: true })
			.then(response => {
				if (response.success) {
					console.log(response.orderDetails);
					return response.orderDetails.map(orderDetail => {
						let detail = {};
						detail = { ...orderDetail };
						detail.rowId = `${detail.deliveryType}${detail.referenceId}`;
						detail.isSelected = false;
						// Readonly orders follow same processibility rules as regular orders.
						// SGR20001032 and "Provided service" restrictions apply equally to both.
						// Readonly status alone does NOT make orders processable - business rules apply uniformly.
						detail.isProcessible = detail.serviceId !== "SGR20001032" && detail.deliveryType !== "Provided service";
						detail.isEmptyLine = false;
						detail.connectedArticles =
							orderDetail.connectedArticles !== undefined
								? orderDetail.connectedArticles
										.select(article => {
											return (article = { ...article, rowId: `${article.soSalesItemNo}`, isSelected: false, isProcessible: detail.deliveryStatus !== "Delivered" });
										})
										.toArray()
								: [];
						return detail;
					});
				} else {
					const errText = response.errorData.error !== undefined ? `${response.errorData.error.message}/${response.errorData.error.code}` : `${response.errorData.message}/${response.errorData.code}`;
					return errorDetails(errText);
				}
			})
			.catch(error => {
				console.log(error);
			});

		return response;
	}
};

export default OrderSearchService;
